/* Actions */
export const UPDATE_LAST_ACTIVITY = "global/UPDATE_LAST_ACTIVITY";
export const REAL_UPDATE_LAST_ACTIVITY = "global/REAL_UPDATE_LAST_ACTIVITY";
export const UPDATE_CLOSED_INACTIVITY_MILLISECONDS = "global/UPDATE_CLOSED_INACTIVITY_MILLISECONDS";

export const ACTIONS_GET_CONFIGURATION_FROM_AEM = {
  GET: "getConfigurationFromAEM/GET",
  REQUEST: "getConfigurationFromAEM/REQUEST",
  SUCCESS: "getConfigurationFromAEM/SUCCESS",
  FAILURE: "getConfigurationFromAEM/FAILURE"
};

export const getConfigurationFromAEM = () => ({
  type: ACTIONS_GET_CONFIGURATION_FROM_AEM.GET
});

export const getConfigurationFromAEMRequest = () => {
  return { type: ACTIONS_GET_CONFIGURATION_FROM_AEM.REQUEST };
};

export const getConfigurationFromAEMSuccess = (data) => ({
  type: ACTIONS_GET_CONFIGURATION_FROM_AEM.SUCCESS,
  payload: data
});

export const getConfigurationFromAEMFailure = (error) => ({
  type: ACTIONS_GET_CONFIGURATION_FROM_AEM.FAILURE,
  payload: { ...error }
});
